import {Span, Text} from '@chakra-ui/react'
import {LuCheck} from 'react-icons/lu'
import {getDatetimeFormatter, joinLabels} from '@cypro/ui/utils'

export function ValidatedLine({label, name, time}: {label: string | null; name?: string | null; time?: number | null}) {
  return (
    <Text color="green.fg" fontSize="sm" fontWeight="medium" spaceX="1">
      <LuCheck size="1rem" style={{minWidth: '1rem', display: 'inline-flex'}} />

      {label && <Span as="span">{label}</Span>}

      <Span as="span" fontWeight="normal">
        {joinLabels([name ?? '-', time ? getDatetimeFormatter().format(time) : null])}
      </Span>
    </Text>
  )
}
